import * as THREE from 'three'
require('three-orbitcontrols');
require("../../../libs/OBJLoader");

import printModel from '../../../3dapps/mixins/printModel';
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'


import { initThree, camera, renderer, incRenderCount } from './mobilPhoneShell';
import { currentGroup, updateMesh, material, makeGroupIfNeeded } from './relief.js';
import Bin1Loader from './Bin1Loader';
import { SourceExporter } from './SourceExporter';
import { baseURL } from '@/request/request.js';
import loading from '@/components/loading';

const contextList = [
"元气满满", "平安喜乐", "大吉大利", "每天进步一点点"
]

let userUploadImageUids = [];

const sampleImageUids = [
"sample,982924ad1b3c4710a11b82384680496f",
"sample,75c4d0f822bb44f08ecf57d9cd12d9f2",
"sample,3232e746f4da4baba5c2af88e14faba6",
"sample,c81ec854232842e4b20a2720f6fc0243",
"sample,abae0caea71a4c8eb6a15bdfdb9d2234",
"sample,dc0613ffdc2b45ec990fad0f6b8a8541",
"sample,5caed036f6b0473b8720cd511bb8f01c",
"sample,d66fafb250b944f98d400f7f834f5e68",
"sample,4a372230e81845cfa57ed2396537957a",
"sample,b3dedfdba39e43f99a6e85a9d7daed8a",
"sample,aa485d58519d471e86eb9f4a276fd281",
"sample,4269b648e79c49c7839c63f8a0df1484",
"sample,99ac1552a2554274bef4704b1ca1f213",
"sample,a985802be6d141429791a459792c66b7",
"sample,8c6d28d8fee446518c7cbf38e768819f",
];

let imgurl;
let imgUid;
let currentObjMesh;
let currenteffect;


function makeImageUrl(uid, process, ext) {
return baseURL + '/makeRelief/getImage/' + uid + '/' + process + ext;
}

export default {
name: "mobilPhoneShell",
mixins: [printModel],
components: {
Group,
XDialog,
Actionsheet,
Grid, GridItem, Radio, Flexbox, FlexboxItem, Tab, TabItem, Swiper, loading, XSwitch
},
data() {
return {
nowIndex: 0,
isShow: false,
quotationName: "3D手机壳",
productType: "手机壳定制",
landscape: true,//竖屏状态要一直为true
showPrint: false,
showText: false,
addCartIndex: -1,
orderIndex: -1,
showLoading: false,//加载动画
printMaterialSelected: '',
draw: {
imageWidth: 1000,//手机端显示用800，后台不同，用1000
image: imgurl,
width: 60,//宽高比
height2: 76, // 浮雕高度
height: 2,//浮雕厚度
thickness: 0.01,//打底厚度
blur: 1,//模糊
useText: true,
text: contextList[Math.floor(Math.random() * contextList.length)],
fontSize: 55,
reverse: false,
effect: "origin",
},
sampleImages: sampleImageUids.map(uid => makeImageUrl(uid, 'thumb', '.png')),
cur: 0, //默认选中第一个tab
btnsList: [{
isClick: false,
icon: require("../imgs/手机.png"),
iconClick: require("../imgs/手机-选中.png"),
title: "手机",
},
{
isClick: false,
icon: require("../imgs/浮雕.png"),
iconClick: require("../imgs/浮雕-选中.png"),
title: "浮雕",
},
{
isClick: false,
icon: require("../imgs/相册.png"),
iconClick: require("../imgs/相册-选中.png"),
title: "相册",
},
{
isClick: false,
icon: require("../imgs/拍照.png"),
iconClick: require("../imgs/拍照-选中.png"),
title: "拍照",
},
], //顶部按钮列表
isreliefBtnIndex: -1,//顶部按钮默认
mobileData: [],
userUploadImages: [],
brandIndexTab: 0,
brandIndex: 0,
modelIndex: 0,
tabreliefList: ["图片", "美化", "文字"],
tabreliefIndex: 0,
tab: 0,//浮雕底部弹窗-初始弹窗值
beautifyIndex: 0,//初始值-美化
beautifyList: [{
effect: "origin",
title: "原图"
}, {
effect: "image-seg",
title: "去背景"
},
],
isShapeIndex: 0,
ossKeyList: [],
}
},
mounted() {
const scope = this;
scope.showLoading = true;
scope.printColorIndex = 4;

scope.loadlistBrand();

var mo = function (e) {
e.preventDefault();
}


var tabList = this.$refs.tabList; 

var screenHeight = window.innerHeight;
window.onresize = function () {
var height = document.documentElement.clientHeight;

if (screenHeight !== window.innerHeight) {

tabList.style.bottom = 0 + "px";
tabList.style.position = "absolute";
} else {

tabList.style.bottom = 50 + "px";
tabList.style.position = "fixed";
}
};
window.addEventListener("resize", onresize);


var interval;


tabList.onfocus = function () {
interval = setInterval(function () {
tabList.style.bottom = 0 + "px";
tabList.style.position = "absolute";
}, 500)
};


tabList.onblur = function () {
tabList.style.bottom = 50 + "px";
tabList.style.position = "fixed";
clearInterval(interval);
};



scope.$nextTick(function () {
scope.$refs.mobilPhoneShell.style.paddingTop = '0px';
scope.$refs.mobilPhoneShell.style.overflow = 'hidden';
scope.$refs.canvas.addEventListener("touchmove", mo, false);
});


initThree(scope.$refs.canvas);
makeGroupIfNeeded();


const contentDOM = scope.$refs.mobilPhoneShell;

const resize1 = function (e) {
if (!scope.$refs.canvas) return;


let w = scope.$refs.canvasBox.clientWidth;
let h = scope.$refs.canvasBox.clientHeight;



scope.$refs.canvas.width = w; 
scope.$refs.canvas.height = h; 



camera.aspect = w / h;

camera.updateProjectionMatrix();

renderer.setSize(w, h);
}

scope.init3d(contentDOM, camera, renderer, resize1);


currenteffect = 'origin';
this.$nextTick(function () {
scope.loadData();
});
},
methods: {

loadData() {
const scope = this;

if (window.localStorage) {
let dataStr = localStorage.getItem("mobilPhoneShell3d");

localStorage.removeItem("mobilPhoneShell3d"); 
if (dataStr) {
let data = JSON.parse(dataStr);
this.draw.width = data.width;
this.draw.height2 = data.height2;
this.isShapeIndex = data.isShapeIndex;
this.draw.effect = data.effect;
this.draw.useText = data.useText;
this.draw.text = data.text;
this.beautifyIndex = data.beautifyIndex;
this.userUploadImages = data.userUploadImages;
this.isSpecsBtnIndex = data.isSpecsBtnIndex;
this.isthicknessIndex = data.isthicknessIndex;
this.isSpecsBtnIndexTemp = this.isSpecsBtnIndex;
this.isthicknessIndexTemp = this.isthicknessIndex;
this.brandIndex = data.brandIndex;
this.modelIndex = data.modelIndex;
this.brandIndexTab = data.brandIndexTab;
this.ossKeyList = this.mobileData[this.brandIndex].models[this.modelIndex].shells[0].ossKey;


this.showLoading = true;

let ext;
if (this.isShapeIndex >= 0) {
imgUid = sampleImageUids[scope.isShapeIndex];
ext = ".png";
} else {
imgUid = userUploadImageUids[scope.userUploadImages.length + scope.isShapeIndex].uid;
ext = userUploadImageUids[scope.userUploadImages.length + scope.isShapeIndex].ext;
}
let src = baseURL + "/makeRelief/getImage/" + imgUid + "/" + this.draw.effect + ext;

let img = new Image();
img.crossOrigin = "anonymous";
img.onload = function () {
scope.draw.image = img;
updateMesh(scope.draw);

scope.showLoading = false;
};
img.src = src;
return;
}
}

let image = new Image();

console.time("first load");
image.crossOrigin = "anonymous";
image.onload = function () {
scope.draw.image = image;

updateMesh(scope.draw);



};
image.src = makeImageUrl(sampleImageUids[0], this.draw.effect, '.png');
},


saveData() {
if (window.localStorage) {
let data = {};
data.width = this.draw.width;
data.height2 = this.draw.height2;
data.height = this.draw.height;
data.useText = this.draw.useText;
data.text = this.draw.text;
data.isShapeIndex = this.isShapeIndex;
data.isSpecsBtnIndex = this.isSpecsBtnIndex;
data.isthicknessIndex = this.isthicknessIndex;
data.effect = this.draw.effect;
data.beautifyIndex = this.beautifyIndex;
data.userUploadImages = this.userUploadImages;
data.brandIndex = this.brandIndex;
data.modelIndex = this.modelIndex;
data.brandIndexTab = this.brandIndexTab;
data.ossKeyList = this.mobileData[this.brandIndex].models[this.modelIndex].shells[0].ossKey;

localStorage.setItem("mobilPhoneShell3d", JSON.stringify(data));
}
},

disposeShellObject() {
if (currentObjMesh) {
if (currentObjMesh.geometry) {
currentObjMesh.geometry.dispose();
} else if (currentObjMesh.children.length > 0) {
currentObjMesh.children.forEach(obj => {
obj.geometry.dispose();
});
}
currentObjMesh = null;
}
},


loadlistBrand() {
const scope = this;

this.$request.post('/phone/listAllData', {
brandName: "1",
}).then(function (res) {
console.log("手机列表",res);
if (res.code == 0) {
scope.mobileData = res.obj;
scope.brandIndex = 0;
scope.modelIndex = 0;
scope.ossKeyList = res.obj[scope.brandIndex].models[scope.modelIndex].shells[scope.modelIndex].ossKey;
}

if (currentObjMesh) {
currentObjMesh.remove(currentObjMesh);
currentGroup.remove(currentObjMesh);
scope.disposeShellObject();
}

setTimeout(function () {
scope.loadData();

let ext = scope.ossKeyList.substr(scope.ossKeyList.lastIndexOf('.')).toLowerCase();
console.time("load shell 1");
if (ext === ".obj") {
new THREE.OBJLoader().load(scope.ossKeyList, function (obj) {
currentGroup.add(obj);
currentObjMesh = obj;
scope.showLoading = false;

}, null, function (err) {

scope.showLoading = false;
});
} else if (ext === ".stl") {
new THREE.STLLoader().load(scope.ossKeyList, function (stl) {
currentGroup.add(stl);
currentObjMesh = stl;
scope.showLoading = false;

}, null, function (err) {

scope.showLoading = false;
});
} else if (ext === ".bin") {
new Bin1Loader().load(scope.ossKeyList, function (geom) {
let obj = new THREE.Mesh(geom, material);
currentGroup.add(obj);
currentObjMesh = obj;
scope.showLoading = false;

}, null, function (err) {

this.$vux.toast.show({
text: '模型加载失败',
type: "warn",
time: 2000,
position: "middle",
});
scope.showLoading = false;
return;
});
}
}, 50);
});


this.$request.post('/phone/listModelByBrandId', {
modelName: "1"
}).then(function (res) {
if (res.code == 0) {
console.log("listModelByBrandId", res);
}
});


this.$request.post('/phone/listShellByModelId', {
modelId: "1",
}).then(function (res) {
if (res.code == 0) {
console.log("listShellByModelId", res);
}
});

},


isSelectBrand(index) {
this.brandIndexTab = index;
},


isSelectModel(index) {
const scope = this;

if (scope.brandIndex === scope.brandIndexTab && scope.modelIndex === index) return;

scope.showLoading = true;

if (currentObjMesh) {
currentGroup.remove(currentObjMesh);
scope.disposeShellObject();
}

scope.brandIndex = scope.brandIndexTab;
scope.modelIndex = index;

scope.ossKeyList = scope.mobileData[scope.brandIndex].models[scope.modelIndex].shells[0].ossKey;

setTimeout(function () {
let ext = scope.ossKeyList.substr(scope.ossKeyList.lastIndexOf('.')).toLowerCase();
console.time("load shell");
if (ext === ".obj") {
new THREE.OBJLoader().load(scope.ossKeyList, function (obj) {
currentGroup.add(obj);
currentObjMesh = obj;
scope.showLoading = false;
}, null, function (err) {

scope.showLoading = false;
});
} else if (ext === ".stl") {
new THREE.STLLoader().load(scope.ossKeyList, function (stl) {
currentGroup.add(stl);
currentObjMesh = stl;
scope.showLoading = false;
}, null, function (err) {

scope.showLoading = false;
});
} else if (ext === ".bin") {
new Bin1Loader().load(scope.ossKeyList, function (geom) {
let obj = new THREE.Mesh(geom, material);
currentGroup.add(obj);
currentObjMesh = obj;
scope.showLoading = false;
}, null, function (err) {

this.$vux.toast.show({
text: '模型加载失败',
type: "warn",
time: 2000,
position: "middle",
});
scope.showLoading = false;
return;
});
}
scope.resize();
}, 50);
},

isTopBtn0() {
if (!this.isClick) {
this.isreliefBtnIndex = -1;
this.btnsList[2].isClick = false;
}
},
isTopBtn1() {
if (!this.isClick) {
this.isreliefBtnIndex = -1;
this.btnsList[3].isClick = false;
}
},


onsmoothsItemClick(index, effect) {
const scope = this;
let ext;
scope.beautifyIndex = index;
scope.draw.effect = effect;


this.showLoading = true;

if (scope.isShapeIndex >= 0) {
imgUid = sampleImageUids[scope.isShapeIndex];
ext = ".png";
} else {
imgUid = userUploadImageUids[scope.userUploadImages.length + scope.isShapeIndex].uid;
ext = userUploadImageUids[scope.userUploadImages.length + scope.isShapeIndex].ext;
}
let src = baseURL + "/makeRelief/getImage/" + imgUid + "/" + this.draw.effect + ext;

let img = new Image();
img.crossOrigin = "anonymous";
img.onload = function () {
scope.draw.image = img;
updateMesh(scope.draw);
scope.showLoading = false;
};
img.src = src;
},


touchstart() {
this.isreliefBtnIndex = -1;
this.btnsList[0].isClick = false;
this.btnsList[1].isClick = false;
this.btnsList[2].isClick = false;
this.btnsList[3].isClick = false;
this.resize();
},


resize() {
let w = document.documentElement.clientWidth;
let h = document.documentElement.clientHeight;
if (this.isreliefBtnIndex == 0 || this.isreliefBtnIndex == 1) {
let tabHeight = h * 0.2;
h = h - tabHeight;
}
camera.aspect = w / h;
camera.updateProjectionMatrix();
renderer.setSize(w, h);
incRenderCount();
},


toggleTabrelief(index) {
this.tabreliefIndex = index;
if (this.tabreliefIndex == 0) {

this.tab = 0;
} else if (this.tabreliefIndex == 1) {

this.tab = 1;
} else {

this.tab = 2;
}
},


onTextClick() {
const scope = this;
scope.showLoading = true;
setTimeout(function () {
updateMesh(scope.draw);
scope.showLoading = false;
}, 50);
},


ontextSure() {
const scope = this;
scope.showLoading = true;
var textValue = scope.$refs.getValue.value;
setTimeout(function () {
if (textValue == "") {
scope.$vux.toast.show({
text: '文本不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
scope.$refs.getValue.value = scope.draw.text;
return;
}
else {
scope.textModel = true;
scope.draw.text = textValue;
}
scope.showLoading = false;
updateMesh(scope.draw);
}, 50);
},



selectFile1() {


this.$refs.btn_import1.click();
},


selectFile2() {


this.$refs.btn_import2.click();
},

onFileChange1(e) {
let file = e.target.files[0];
if (!file) {
return;
};



if (file.type == "text/plain") {
this.$vux.toast.show({
text: '只能上传图片，图片格式必须为PNG格式',
type: "warn",
time: 2000,
position: "middle",
});
return;
} else {

let formData = new FormData();
formData.append("img", file);
this.$request.post("/makeRelief/addImage", formData, {
headers: {
'Content-Type': 'multipart/form-data'
}
}).then(res => {

userUploadImageUids.unshift({
uid: res.obj.img_uid,
ext: res.obj.ext
});
});
let url = URL.createObjectURL(file);
this.userUploadImages.unshift(url);
this.isShapeIndex = -this.userUploadImages.length;

this.showLoading = true;
const scope = this;
let img = new Image();
img.crossOrigin = "anonymous";
img.onload = function () {
scope.draw.image = img;
updateMesh(scope.draw);
scope.showLoading = false;
};
img.src = url;
scope.showLoading = false;
}
},


handler(index) {
let isreliefBtnIndex = this.isreliefBtnIndex;

if (isreliefBtnIndex === index) {
this.btnsList[index].isClick = !this.btnsList[index].isClick;
this.isreliefBtnIndex = -1;
} else {
this.btnsList[index].isClick = true;
this.isreliefBtnIndex = index;

if (isreliefBtnIndex !== -1) {
this.btnsList[isreliefBtnIndex].isClick = false;
}
}


if (index === 2 || index === 3) {
if (index === 2) {
this.selectFile1();
this.isTopBtn0();
} else {
this.selectFile2();
this.isTopBtn1();
}
}

if (isreliefBtnIndex === 2 || isreliefBtnIndex === 3) {
this.beautifyIndex = 0;
this.isreliefBtnIndex = -1;
this.resize();
}
this.resize();
},


seleShapeItem(index) {
const scope = this;
scope.isShapeIndex = index;
scope.showLoading = true;

if (scope.isShapeIndex >= 0) {
let img = new Image();
img.crossOrigin = "anonymous";
img.onload = function () {
scope.draw.image = img;
updateMesh(scope.draw);
scope.showLoading = false;
};
img.src = makeImageUrl(sampleImageUids[scope.isShapeIndex], this.draw.effect, '.png');
} else {

scope.draw.image = scope.$refs['img2-' + (scope.isShapeIndex + scope.userUploadImages.length)][0];
scope.beautifyIndex = 0;
updateMesh(scope.draw);
scope.showLoading = false;
}
},

getModelToPrint() {
return currentGroup;
},

makeStlBlob() {
let sourceExporter = new SourceExporter();
let sourceBlob = sourceExporter.makeBlob(this.draw);
return sourceBlob;
},

getUploadUrl() {
return "/phone/makeModel";
},

addOtherData(formData) {
let shellId = this.mobileData[this.brandIndex].models[this.modelIndex].shells[0].id;
formData.append("shellId", shellId);
},


print() {
this.modelSplit = true;
this.showLoading = true;



if (this.lowPrice == 0 && this.total <= 5 || this.total == 5) {
this.showlow = true;
this.showStyle = false;
this.showlowpriceHeight = true;

}
if (this.lowPrice == 1 && this.total > 5 || this.total > 5 || this.lowPrice == "") {
this.showlow = false;
this.showStyle = true;
this.showlowpriceHeight = false;

}

if (currentGroup) {














this.saveData();
this.$nextTick(function () {
this.showPrint = true;
this.makeModelForPrint();
const scope = this;
scope.getPrice();
scope.showLoading = false;
});

} else {
this.$vux.toast.show({
text: '3D手机壳不能为空！',
type: "warn",
time: 2000,
position: "middle",
});
this.refresh3d();
this.showLoading = false;
}
},

exporter() {
let exporter = new THREE.STLExporter();
let result = exporter.parse(currentGroup, {
binary: true
});
let blob = new Blob([result], {
type: 'application/octet-stream'
});

let filename = "model.stl";
let link = document.createElement("a");
link.href = URL.createObjectURL(blob);
link.download = filename;
link.click();
},
},
}


// WEBPACK FOOTER //
// ./src/views/mobilPhoneShell3d/scripts/index.js